// extracted by mini-css-extract-plugin
var _1 = "_productSettingsTable-module__action-button-container";
var _2 = "_productSettingsTable-module__danger";
var _3 = "_productSettingsTable-module__delete-btn";
var _4 = "_productSettingsTable-module__edit-btn";
var _5 = "_productSettingsTable-module__gold-row";
var _6 = "_productSettingsTable-module__view-btn";
export { _1 as "action-button-container", _2 as "danger", _3 as "delete-btn", _4 as "edit-btn", _5 as "gold-row", _6 as "view-btn" }
